import React, { useContext, useState } from "react";
import styled from "@emotion/styled";
import colors, { StyledForm, Success, Cancel } from "./UiComponent";
import { useFormik } from "formik";
import { css } from "@emotion/react";
import * as yup from "yup";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
//context provider

import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Box,
  Typography,
  FormLabel,
  Dialog,
} from "@mui/material";
import { FormatLineSpacing } from "@mui/icons-material";
import {
  col,
  formGroupContainer,
  groupStyled,
  header,
  labelStyled,
  row,
} from "./styles";
import ImportStaff from "./ImportStaff";
import { CircularProgressWithLabel } from "../../components/200/CircularProgressWithLabel";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";
import StaffContext from "../../context/StaffManagementContext";
import OfficeContext from "../../context/OfficeContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useEffect } from "react";

const validationSchema = yup.object({
  rank_id: yup
    .string("Enter staff Academic Rank")
    .required("Staff Academic Rank is required"),
  email: yup
    .string("Enter staff email Adress")
    .email()
    .required("Email Adress is requiered"),
  status_id: yup
    .string("Enter the status of the staff")
    .required("status of the staff is required"),
  start_date: yup
    .date("Enter the starting date")
    .required("Starting date is required"),
  department: yup
    .string("Select Department")
    .required("Department is required"),
});

function EditStaff(match) {
  let navigate = useNavigate();
  let location = useLocation();
  let api = useAxiosPrivate();

  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const staffContext = useContext(StaffContext);
  const officeContext = useContext(OfficeContext);
  const staff = staffContext.state.filter(
    (staff) => staff.id === location.state.id
  )[0];
  console.log(staff.start_date.slice(0, 10));

  useEffect(() => {
    api.get("office/offices").then((res) => {
      officeContext.officeDispatch({
        type: "loadOffice",
        offices: res.data.offices,
      });
    });
    api
      .get("rank/ranks")
      .then((res) => {
        console.log("Rank from the database", res);
        staffContext.rankDispatch({
          type: "loadRanks",
          ranks: res.data.ranks,
        });
      })
      .catch((err) => console.log(err));
    api.get("status/statuses").then((res) => {
      console.log("From the database", res);
      staffContext.statusDispatch({
        type: "loadStatus",
        statuses: res.data.statuses,
      });
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      email: staff?.email,
      status_id: staff?.status?.id,
      rank_id: staff?.rank?.id,
      start_date: staff?.start_date.slice(0, 10),
      department: staff?.office?.id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let newValues = { ...values, id: location.state.id };
      api
        .patch("staff/updateStaff", newValues)
        .then((response) => {
          alert(JSON.stringify(response, null, 2));
          setAdding(false);
          navigate("../", {
            state: {
              message: { message: "Updated Successfully", type: "success" },
              open: true,
            },
          });
        })
        .catch((err) => {
          alert(JSON.stringify(err.response.data, null, 2));
          setMessage({
            message: err.response.data,
            type: "error",
          });
        });
    },
  });
  return (
    <StyledForm onSubmit={formik.handleSubmit}>
      <Box sx={header}>
        <Typography
          variant="span"
          sx={{
            fontSize: "1.14rem",
            fontWeight: "600",
            lineHeight: "23.2px",
            color: "primary.main",
          }}
        >
          Staff Update Form
        </Typography>
      </Box>
      <Box sx={formGroupContainer}>
        <Box sx={{ ...col }}>
          <FormControl sx={groupStyled}>
            <FormControl sx={groupStyled}>
              <FormLabel htmlFor="status_id" sx={labelStyled}>
                Department
              </FormLabel>
              <TextField
                id="department"
                name="department"
                onChange={formik.handleChange}
                error={
                  formik.touched.department && Boolean(formik.errors.department)
                }
                value={formik.values.department}
                helperText={
                  formik.touched.department && formik.errors.department
                }
                select
              >
                {officeContext.officeState.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>{" "}
            <FormLabel sx={labelStyled}>E-mail</FormLabel>
            <TextField
              id="email"
              name="email"
              disabled
              value={formik.values.email}
              onChange={(e) => {
                setSnackBarOpen(false);
                formik.handleChange(e);
              }}
              error={formik.errors.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              fullWidth
            />
          </FormControl>
          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="rank_id" sx={labelStyled}>
              Academic Rank
            </FormLabel>
            <TextField
              id="rank_id"
              name="rank_id"
              onChange={formik.handleChange}
              error={formik.touched.rank_id && Boolean(formik.errors.rank_id)}
              value={formik.values.rank_id}
              helperText={formik.touched.rank_id && formik.errors.rank_id}
              select
            >
              {staffContext.rankState.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.academic_type}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Box>
        <Box sx={col}>
          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="status_id" sx={labelStyled}>
              Status
            </FormLabel>
            <TextField
              id="status_id"
              name="status_id"
              onChange={formik.handleChange}
              error={
                formik.touched.status_id && Boolean(formik.errors.status_id)
              }
              value={formik.values.status_id}
              helperText={formik.touched.status_id && formik.errors.status_id}
              select
            >
              {staffContext.statusState.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.type}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>{" "}
          <FormControl sx={groupStyled} fullWidth>
            <FormLabel sx={labelStyled} htmlFor="start_date">
              Starting Date
            </FormLabel>
            <TextField
              type="date"
              id="start_date"
              name="start_date"
              value={formik.values.start_date}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={
                formik.errors.start_date && Boolean(formik.errors.start_date)
              }
              helperText={formik.touched.start_date && formik.errors.start_date}
            />
          </FormControl>
        </Box>
      </Box>
      {snackBarOpen && (
        <CustomizedSnackbars {...{ setSnackBarOpen, snackBarOpen, message }} />
      )}

      <Box
        sx={{
          display: "flex",
          gap: "1.8rem",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <Button variant="outlined" color="third">
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: "secondary.lighter1",
            "&:hover": {
              backgroundColor: "secondary.main",
            },
          }}
        >
          {adding ? <CircularProgressWithLabel size={18} /> : "Update"}
        </Button>
      </Box>
    </StyledForm>
  );
}

export default EditStaff;
